import request from "utils/request";
import requestThirdparty from "utils/request/requestThirdparty";

// 获取总的质押数量
export const getTotalVXCHNGStaked = async () => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.get('/getTotalVXCHNGStaked')
        if(code === 0) {
            return data
        }
    } catch(error) {
        throw error
    }
}

// 获取用户的投票数量
export const getUserVXCHNGBalance = async (user: string) => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.get('/getUserVXCHNGBalance', {
            params: {user}
        })
        if(code === 0) {
            return data
        }
    } catch(error) {
        throw error
    }
}


// 获取用户质押交易记录
export const getUserVXCHNGStakes = async (user: string) => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.get('/getUserVXCHNGStakes', {
            params: {user}
        })
        if(code === 0) {
            return data
        }
    } catch(error) {
        throw error
    }
}

// 获取Dashboard基础信息记录
export const getDashboardInfo = async () => {
    try {
        const {code = -1, data = {}, msg=''}: any = await requestThirdparty.get('/dao/getDashboardInfo')
        if(code === 0) {
            return data
        }
    } catch(error) {
        
    }
}

// 获取季度奖励
export const getVShareClaimable = async (params: {address: string, period: string}) => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.get('/getVShareClaimable', {params})
        if(code === 0) {
            return data
        }
    } catch(error) {
        throw error
    }
}


export const getVShareClaimed = async (params: {address: string, period: string}) => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.get('/getVShareClaimed', {params})
        if(code === 0) {
            return data
        }
    } catch(error) {
        throw error
    }
}
